import { Config } from '@/types';
import { FormikProps } from 'formik';

export const shouldRenderFieldByDependsOn = ({
  field,
  formik,
}: {
  field: Config.Field;
  formik: FormikProps<Record<string, string>>;
}) => {
  if (field.dependsOn) {
    return field.dependsOn.value === formik.values[field.dependsOn.name];
  }
  return true;
};
